import { Text } from "@meditect/medibase-components";

export const SalesCannotCloseSaleWithoutPharmacyIdError = () => {
  return <Text>Pharmacie non définie</Text>;
};
